<div class="flex-1 d-flex fd-col jc-center ai-center">
  <suvo-core-loading-spinner></suvo-core-loading-spinner>
</div>